import ServicePageHero from "../components/ServicePageHero";
import { openConsultationMail } from "../config/contact";
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiArrowUpRight, FiPlus, FiChevronDown, FiChevronUp, FiUsers, FiShare2, FiTrendingUp, FiBarChart2 } from "react-icons/fi";
import { Helmet } from "react-helmet-async";
import ServiceDetailSection from "../components/ServiceDetailSection";
import ServiceIntroSection from "../components/ServiceIntroSection";
import img_social_growth_bro from "../assets/Social Growth-bro.png";
import img_social_growth_rafiki from "../assets/Social Growth-rafiki.png";
import img_social_media_amico from "../assets/Social media-amico.png";
import img_social_media_rafiki from "../assets/Social media-rafiki.png";
import img_social_strategy_amico from "../assets/Social strategy-amico.png";
import img_social_strategy_bro from "../assets/Social strategy-bro.png";
import img_about_img1 from "../assets/Choose-bro.png";
import img_about_img2 from "../assets/Starting a business project-amico.png";

// Using specific assets for Social Media 

const FAQ_DATA = [
  {
    question: "1. What is social media marketing?",
    answer: "Social media marketing involves promoting your business on platforms like Instagram, Facebook, and LinkedIn to connect with your audience, build brand awareness, and increase engagement."
  },
  {
    question: "2. Which platforms are best for my business?",
    answer: "The right platforms depend on your business type and target audience. We help you choose platforms like Instagram, Facebook, or LinkedIn based on where your audience is most active."
  },
  {
    question: "3. How often should I post on social media?",
    answer: "Consistency is key. Most businesses benefit from posting 3–5 times per week, depending on their goals and content strategy."
  },
  {
    question: "4. Can social media marketing generate leads?",
    answer: "Yes, with the right strategy, social media can help generate leads, drive website traffic, and improve brand visibility."
  }
];

const scrollReveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.6, ease: "easeOut" },
};

const staggerContainer = {
  initial: {},
  whileInView: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const itemFade = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.5, ease: "easeOut" },
};


const WHY_ICONS = [
  <FiUsers />,
  <FiShare2 />,
  <FiTrendingUp />,
  <FiBarChart2 />,
];
const SocialMediaMarketingPage = () => {
  const [openFaq, setOpenFaq] = useState(null);
  const [activeWhy, setActiveWhy] = useState(0);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const scrollToContact = openConsultationMail; // replaced

  return (
    <>
      <Helmet>
        <title>Social Media Marketing Services Company in India</title>
        <meta name="description" content="Grow your brand with social media marketing services. Hire experts for Facebook, Instagram, and LinkedIn marketing to increase engagement and leads." />
      </Helmet>
      <main className="social-media-page">
      <ServicePageHero
        badge="Our Services"
        title="Best Social Media Marketing"
        subtitle="Build a strong presence, engage your audience, and grow your brand with effective social media strategies."
        breadcrumb="Home > Services > Social Media"
        image={img_social_media_amico}
      />


      {/* INTRO SECTION */}
      <ServiceIntroSection
        heading="Build Your Brand With Social Media Marketing"
        imageLeft={img_social_strategy_amico}
        imageRight={img_social_growth_rafiki}
        paragraph1="Social media marketing helps your business connect with the right audience and build a strong online presence across platforms like Instagram, Facebook, and LinkedIn."
        paragraph2="As a results-driven social media agency, we focus on creating engaging content, improving brand visibility, and driving meaningful interactions."
      />

      <ServiceDetailSection
        isReversed={false}
        label="Our Social Marketing Strategy"
        title="Content Strategy & Planning"
        description="We create a clear content strategy based on your business goals, audience behavior, and platform trends. This helps in delivering content that is relevant and aligned with your brand."
        longDescription="With proper planning, we ensure consistency in posting and messaging, helping your brand stay active and visible."
        image={img_social_strategy_bro}
      />

      <ServiceDetailSection
        isReversed={true} bgLight
        title="Content Creation & Design"
        description="We design high-quality creatives, captions, and posts that reflect your brand identity. Our focus is on creating visually appealing and engaging content."
        longDescription="This helps capture attention, increase interaction, and build a strong connection with your audience."
        image={img_social_growth_bro}
      />

      <ServiceDetailSection
        isReversed={false}
        title="Audience Engagement & Growth"
        description="We actively engage with your audience through comments, messages, and interactions. This helps in building trust and creating a loyal community."
        longDescription="Our strategies focus on increasing followers, improving engagement, and strengthening your online presence."
        image={img_social_media_rafiki}
      />

      <ServiceDetailSection
        isReversed={true} bgLight
        title="Performance Tracking & Optimization"
        description="We monitor key metrics like reach, engagement, and growth to understand performance. Based on insights, we continuously optimize strategies."
        longDescription="This ensures your social media marketing delivers consistent and measurable results."
        image={img_social_media_amico}
      />

      {/* WHY CHOOSE US - REDESIGNED DARK VERSION */}
      <section className="dark-why-section">
        <div className="container-custom">
          <motion.div className="dark-why-header" {...scrollReveal}>
            <span className="dark-why-badge">Why Choose Us</span>
            <h2>Why Businesses Trust Our Social Media Expertise</h2>
          </motion.div>

          <motion.div 
            className="dark-why-grid"
            variants={staggerContainer}
            initial="initial"
            whileInView="whileInView"
            viewport={{ once: true, amount: 0.1 }}
          >
            {/* Left: Accordion List */}
            <motion.div className="dark-why-list" variants={itemFade}>
              {[
                { 
                  title: "1. Tailored Strategies for Every Brand", 
                  desc: "We create social media strategies based on your business goals, audience, and industry. This ensures your content is relevant and effective. Our customized approach helps in building a strong and consistent brand presence." 
                },
                { 
                  title: "2. Consistent & Engaging Content", 
                  desc: "We focus on maintaining consistency in posting and delivering content that engages your audience. This helps in keeping your brand active and visible. Engaging content improves interaction and builds long-term audience trust." 
                },
                { 
                  title: "3. Focus on Real Growth", 
                  desc: "Our goal is to increase engagement, reach, and brand awareness. We focus on strategies that bring real and measurable growth. This helps your business connect with the right audience and generate better opportunities." 
                },
                { 
                  title: "4. Data-Driven Optimization", 
                  desc: "We track performance and use data insights to improve strategies continuously. This ensures better results over time. With regular analysis, we refine content and approach for maximum impact." 
                }
              ].map((item, idx) => (
                <div 
                  key={idx} 
                  className={`dark-why-item ${activeWhy === idx ? 'active' : ''}`}
                  onMouseEnter={() => setActiveWhy(idx)}
                >
                  <div className="dark-why-item-header">
                    <span className="dark-why-item-icon-left">{WHY_ICONS[idx]}</span>
                    <h4>{item.title}</h4>
                    <span className="dark-why-item-icon">
                      {activeWhy === idx ? <FiArrowUpRight /> : <FiPlus />}
                    </span>
                  </div>
                  <div className="dark-why-item-content">
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </motion.div>

            {/* Right: Visual Ovals */}
            <motion.div className="dark-why-visual" variants={itemFade}>
              <img src={img_about_img1} alt="Expertise 1" className="dark-oval-1" />
              <img src={img_about_img2} alt="Expertise 2" className="dark-oval-2" />
              <span className="dark-deco-plus"><FiPlus /></span>
              <span className="dark-deco-star">✷</span>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="faq-section py-20">
        <div className="container-custom max-w-4xl">
          <motion.h2 className="section-title text-center mb-16" {...scrollReveal}>Frequently Asked Questions</motion.h2>
          <div className="faq-list">
            {FAQ_DATA.map((faq, index) => (
              <motion.div 
                key={index} 
                className={`faq-item ${openFaq === index ? 'active' : ''}`}
                {...scrollReveal}
                transition={{ delay: index * 0.1 }}
              >
                <button className="faq-question" onClick={() => toggleFaq(index)}>
                  <span>{faq.question}</span>
                  {openFaq === index ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                <AnimatePresence>
                  {openFaq === index && (
                    <motion.div 
                      className="faq-answer"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <p>{faq.answer}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="service-page-cta service-page-cta--soft py-20">
        <div className="container-custom">
          <motion.div 
            className="service-page-cta-inner text-center"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2>Let’s Strengthen Your Social Media Presence</h2>
            <p className="mb-8">Our social media marketing services in Delhi NCR are designed to increase engagement, build brand awareness, and connect you with the right audience.</p>
            <button className="nav-btn mx-auto" onClick={scrollToContact} style={{ padding: '14px 32px', fontSize: '16px' }}>
              Get Free Consultation
              <span className="nav-btn-arrow" style={{ width: '28px', height: '28px' }}>
                <FiArrowUpRight />
              </span>
            </button>
          </motion.div>
        </div>
      </section>
      </main>
    </>
  );
};

export default SocialMediaMarketingPage;
